/**
 * Карта разделов кабинета агента (DEV-1265).
 *
 * Отдельная ручка, а не поле в /me: ответ /me лежит в 30-секундном кэше
 * валидации токена и в кэшах интерцептора каждого сервиса, где per-app поле
 * кэшировалось бы неверно.
 */
import { apiClient } from '@/api'

export interface AppSectionDto {
  key: string
  /**
   * ⚠️ Именно snake_case: gateway auth маршалит proto-именами (`sort_order`),
   * а не lowerCamelCase. С полем sortOrder сортировка молча даёт NaN и держится
   * лишь на том, что сервер отдаёт уже упорядоченный список — до первого
   * изменения на бэкенде (DEV-1253).
   */
  sort_order: number
}

export interface ListMySectionsResponse {
  sections?: AppSectionDto[]
}

export const sectionsApi = {
  /**
   * GET /api/v1/auth/sections?app=agent_cabinet
   *
   * Приложение передаётся явно: пустое значение сервер трактует как crm, и
   * кабинет получил бы чужую карту.
   */
  async listMySections(app = 'agent_cabinet'): Promise<ListMySectionsResponse> {
    const response = await apiClient.get<ListMySectionsResponse>('/api/v1/auth/sections', {
      params: { app },
    })

    return response.data
  },
}
